import { useCallback } from "react";
import useAuth from "./useAuth";

interface DownloadOptions {
  id: number | string;
  type?: string;
}
interface UseDownloadReturn {
  download: (options: DownloadOptions) => void;
}

const SERVER_BASE = import.meta.env.EDS_SERVER_BASE_URL;

export function useDownload(): UseDownloadReturn {
  const { getToken } = useAuth();
  const auth = getToken() as string;

  const downloadFile = useCallback((data : DownloadOptions) => {

    const url = `${SERVER_BASE}/exercises/${data.id}/print?type=media&auth=${btoa(auth)}`;

    window.open(url, '_blank');
  }, [auth]);

  return {
    download: downloadFile,
  };
}
